<template>
  <v-container fluid>
    <v-card>
      <v-row no-gutters align="center">
        <v-col>
          <v-card-title> Case Groups </v-card-title>
          <v-card-subtitle>{{ getOrg }}</v-card-subtitle>
        </v-col>
        <v-col align="right">
          <v-btn
            class="ma-3"
            fab
            dark
            x-small
            color="green"
            @click="onAddClick()"
          >
            <v-icon dark>mdi-plus</v-icon>
          </v-btn>
          <v-btn
            class="ma-3"
            fab
            dark
            x-small
            color="blue"
            @click="onRefreshClick()"
          >
            <v-icon dark>mdi-refresh</v-icon>
          </v-btn>
        </v-col>
      </v-row>
    </v-card>

    <v-row class="mt-10">
      <v-col>
        <v-data-table :headers="headers" :items="caseGroups" :loading="loading">

          <template v-slot:item.id="{ item }">
            <code>{{ item.id }}</code>
          </template>
          
          <template v-slot:item.nextScreeningDate="{ item }">
            {{ formatDate(item.nextScreeningDate) }}
          </template>

          <template v-slot:item.lastScreeningDate="{ item }">
            {{ formatDateTime(item.lastScreeningDate) }}
          </template>

          <template v-slot:item.screeningJobRunning="{ item }">
            <v-icon v-if="item.screeningJobRunning" color="red" small >mdi-circle</v-icon>
          </template>
          
          <template v-slot:item.controls="props">
            <v-btn
              icon
              x-small
              color="blue"
              @click="onEditClick(props.item)"
            >
              <v-icon dark>mdi-pencil</v-icon>
            </v-btn>

            <v-btn
              class="ml-1"
              icon
              x-small
              color="red"
              @click="onDeleteClick(props.item)"
            >
              <v-icon dark>mdi-delete</v-icon>
            </v-btn>
          </template>
        </v-data-table>
      </v-col>
    </v-row>

    <AddCaseGroup
      :loading="modalLoading"
      :visible="isAddDialogVisible"
      :groupFrequencyOptions="getGroupFrequencyOptions"
      :users="users"
      v-on:onClose="onAddCaseGroupClose"
    />

    <EditCaseGroup
      v-if="selectedCaseGroup"
      :caseGroup="selectedCaseGroup"
      :visible="isEditDialogVisible"
      :groupFrequencyOptions="getGroupFrequencyOptions"
      :users="users"
      v-on:onClose="onEditCaseGroupClose"
    />

    <Confirm ref="confirm"></Confirm>
  </v-container>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import AddCaseGroup from "../modals/case groups/AddCaseGroup";
import EditCaseGroup from "../modals/case groups//EditCaseGroup";
import Confirm from "../modals/Confirm";
import { formatDate, formatDateTime } from "../utils/dateUtils";
export default {
  name: "CaseGroups",
  components: {
    AddCaseGroup,
    EditCaseGroup,
    Confirm,
  },
  data() {
    return {
      loading: false,
      isAddDialogVisible: false,
      isEditDialogVisible: false,
      selectedCaseGroup: null,
      modalLoading: false,
      error: "",
      headers: [
        { text: "Name", value: "name" },
        { text: "ID", value: "id" },
        // { text: "Description", value: "description" },
        { text: "Screening", value: "groupScreeningFrequency" },
        { text: "Assignee", value: "defaultAssignedUser.name" },
        { text: "Last Screening", value: "lastScreeningDate" },
        { text: "Next Screening", value: "nextScreeningDate" },
        { text: "Currently Screening", value: "screeningJobRunning", align: 'center'},
        { text: "Admin", value: "controls", sortable: false, align: "right" },
      ],
    };
  },
  methods: {
    formatDate,
    formatDateTime,
    ...mapActions([
      "getUsers",
      "fetchCaseGroups",
      "setGlobalAlert",
      "addCaseGroup",
      "updateCaseGroup",
      "deleteCaseGroup",
    ]),
    onAddClick: function () {
      this.isAddDialogVisible = true;
    },
    onRefreshClick: function(){
      this.refresh();
    },
    onEditClick: function (selectedCaseGroup) {
      this.selectedCaseGroup = { ...selectedCaseGroup };
      this.isEditDialogVisible = true;
    },
    onDeleteClick: function (caseGroup) {
      this.$refs.confirm
        .open(
          "Delete this case screening group?",
          "You are about to delete the " +
            caseGroup.name +
            " screening group, which cannot be undone. Any cases assigned to this group will be unassigned. ",
          { color: "red" }
        )
        .then((confirm) => {
          if (confirm) {
            this.loading = true;
            this.deleteCaseGroup(caseGroup)
            .finally(() => {
              this.loading = false;
            });
          }
        });
    },
    onAddCaseGroupClose() {
      this.isAddDialogVisible = false;
    },
    onEditCaseGroupClose() {
      this.isEditDialogVisible = false;
    },
    async refresh() {
      this.loading = true;
      await this.fetchGroupsAndUsers().finally(() => {
        this.loading = false;
      });
    },
    async fetchGroupsAndUsers(){
      await this.getUsers();
      await this.fetchCaseGroups();
    }
  },
  computed: {
    ...mapGetters(["getOrg", "getGroupFrequencyOptions", "users"]),
    caseGroups() {
      return this.$store.state.caseGroups.caseGroups;
    },
  },
  async created() {

    // Refresh the table only if it's empty (first time viewed) OR users is empty
    if (!this.$store.state.caseGroups.caseGroups.length || !this.$store.state.users.users.length) {
      await this.refresh().catch((e) => {
        console.log("Error getting groups or cases: " + e);
        this.setGlobalAlert({
          alert: true,
          color: 'red',
          alertTitle: "There's been a problem.",
          alertMessage: "Unable to load case groups, please try again.",
        });
      });
    }
  },
};
</script>
  